

jQuery(document).ready(function($) {    

	function loadMasonry(){

	    //$container will always be a new copy
	    var $container = $('.news-index-grid');

	    //running images loaded again after page load / ajax event 
	    $container.imagesLoaded(function () {
	        // INITIALIZE MASONRY
	        $container.masonry({
	            itemSelector: '.grid-item',
			    columnWidth: '.grid-sizer',
			    gutter: 30,
			    percentPosition: true
	        });
	        // Masonry has been initialized, okay to call methods
	        // reload masonry
	        $container.masonry('reloadItems');
	    });
	}

	//Call on page load etc...
	loadMasonry();

	//then also call it after ajax event
	$(document).on("sf:ajaxfinish", ".searchandfilter", function () {
	    console.log("ajax complete");
	    loadMasonry();
	});


});
